(function () {
  // Guard against the script being included once per section instance
  if (window.SocialCarousel) return;

  var DRAG_THRESHOLD = 5;
  var EDGE_TOLERANCE = 2;

  var reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function SocialCarousel(root) {
    this.root = root;
    this.track = root.querySelector('.js-social-carousel-track');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('.js-social-carousel-slide'));
    this.header = root.querySelector('.js-social-carousel-header');
    this.nav = root.querySelector('.js-social-carousel-nav');
    this.prev = root.querySelector('.js-social-carousel-prev');
    this.next = root.querySelector('.js-social-carousel-next');
    this.status = root.querySelector('.js-social-carousel-status');
    this.videoCards = Array.prototype.slice.call(root.querySelectorAll('.js-social-carousel-video-card'));
    this.hasIntro = !!root.querySelector('.social-carousel__intro');

    this.userInteracted = false;
    this.suppressClick = false;
    this.drag = null;
    this.scrollFrame = null;
    this.announceTimer = null;

    if (!this.track || !this.slides.length) return;

    this.bindNav();
    this.bindKeyboard();
    this.bindDrag();
    this.bindScroll();
    this.bindResize();
    this.bindVideos();
    this.update();
  }

  /* Carousel */

  SocialCarousel.prototype.getMaxScroll = function () {
    return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
  };

  SocialCarousel.prototype.hasOverflow = function () {
    return this.getMaxScroll() > EDGE_TOLERANCE;
  };

  SocialCarousel.prototype.getStep = function () {
    var first = this.slides[0];
    var second = this.slides[1];

    if (second) return second.offsetLeft - first.offsetLeft;
    return first.offsetWidth;
  };

  SocialCarousel.prototype.getCurrentIndex = function () {
    var step = this.getStep();
    if (!step) return 0;
    return Math.round(this.track.scrollLeft / step);
  };

  SocialCarousel.prototype.goToIndex = function (index) {
    var step = this.getStep();
    var lastIndex = this.slides.length - 1;
    var target = Math.max(0, Math.min(index, lastIndex));

    this.track.scrollTo({ left: Math.min(target * step, this.getMaxScroll()) });
  };

  SocialCarousel.prototype.go = function (direction) {
    this.userInteracted = true;

    if (direction > 0 && this.isAtEnd()) return;
    if (direction < 0 && this.isAtStart()) return;

    this.goToIndex(this.getCurrentIndex() + direction);
  };

  SocialCarousel.prototype.isAtStart = function () {
    return this.track.scrollLeft <= EDGE_TOLERANCE;
  };

  SocialCarousel.prototype.isAtEnd = function () {
    return this.track.scrollLeft >= this.getMaxScroll() - EDGE_TOLERANCE;
  };

  SocialCarousel.prototype.update = function () {
    var overflow = this.hasOverflow();

    if (this.nav) this.nav.hidden = !overflow;
    if (this.header) this.header.hidden = !this.hasIntro && !overflow;
    if (this.prev) this.prev.setAttribute('aria-disabled', String(!overflow || this.isAtStart()));
    if (this.next) this.next.setAttribute('aria-disabled', String(!overflow || this.isAtEnd()));

    this.track.classList.toggle('is-draggable', overflow);
  };

  SocialCarousel.prototype.getVisibleRange = function () {
    var trackRect = this.track.getBoundingClientRect();
    var first = -1;
    var last = -1;

    this.slides.forEach(function (slide, index) {
      var rect = slide.getBoundingClientRect();
      var inView = rect.left >= trackRect.left - EDGE_TOLERANCE && rect.right <= trackRect.right + EDGE_TOLERANCE;

      if (!inView) return;
      if (first < 0) first = index;
      last = index;
    });

    if (first < 0) {
      first = this.getCurrentIndex();
      last = first;
    }

    return { first: first + 1, last: last + 1 };
  };

  SocialCarousel.prototype.announce = function () {
    if (!this.status || !this.userInteracted) return;

    var range = this.getVisibleRange();
    var total = this.slides.length;

    this.status.textContent =
      range.first === range.last
        ? 'Showing post ' + range.first + ' of ' + total
        : 'Showing posts ' + range.first + ' to ' + range.last + ' of ' + total;
  };

  SocialCarousel.prototype.bindNav = function () {
    var self = this;

    if (this.prev) {
      this.prev.addEventListener('click', function () {
        if (self.prev.getAttribute('aria-disabled') === 'true') return;
        self.go(-1);
      });
    }

    if (this.next) {
      this.next.addEventListener('click', function () {
        if (self.next.getAttribute('aria-disabled') === 'true') return;
        self.go(1);
      });
    }
  };

  SocialCarousel.prototype.bindKeyboard = function () {
    var self = this;

    this.root.addEventListener('keydown', function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;

      // Leave the arrow keys to the native video controls while a video is active
      if (event.target.closest && event.target.closest('.js-social-carousel-video')) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.go(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.go(1);
      }
    });
  };

  SocialCarousel.prototype.bindDrag = function () {
    var self = this;
    var track = this.track;

    // Links and images are natively draggable, which would hijack the mouse drag
    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !self.hasOverflow()) return;

      // Don't start a drag from the native controls of an active video
      if (event.target.closest && event.target.closest('.is-playing .js-social-carousel-video')) return;

      self.drag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startScroll: track.scrollLeft,
        active: false,
      };
    });

    track.addEventListener('pointermove', function (event) {
      var drag = self.drag;
      if (!drag || event.pointerId !== drag.pointerId) return;

      var deltaX = event.clientX - drag.startX;

      if (!drag.active) {
        if (Math.abs(deltaX) < DRAG_THRESHOLD) return;

        // Only capture once it's a real drag, so plain clicks still reach the card links
        drag.active = true;
        self.userInteracted = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(drag.pointerId);
        if (window.getSelection) window.getSelection().removeAllRanges();
      }

      event.preventDefault();
      track.scrollLeft = drag.startScroll - deltaX;
    });

    function endDrag(event) {
      var drag = self.drag;
      if (!drag || event.pointerId !== drag.pointerId) return;

      self.drag = null;
      if (!drag.active) return;

      self.suppressClick = true;
      window.setTimeout(function () {
        self.suppressClick = false;
      }, 0);

      if (track.hasPointerCapture(drag.pointerId)) {
        track.releasePointerCapture(drag.pointerId);
      }

      track.classList.remove('is-dragging');

      // Snap is disabled while dragging, so settle on the nearest card ourselves
      if (!self.isAtEnd()) {
        self.goToIndex(self.getCurrentIndex());
      }
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (event) {
        if (!self.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        self.suppressClick = false;
      },
      true
    );
  };

  SocialCarousel.prototype.bindScroll = function () {
    var self = this;

    this.track.addEventListener(
      'scroll',
      function () {
        if (self.scrollFrame) return;

        self.scrollFrame = window.requestAnimationFrame(function () {
          self.scrollFrame = null;
          self.update();
        });

        window.clearTimeout(self.announceTimer);
        self.announceTimer = window.setTimeout(function () {
          self.announce();
        }, 200);
      },
      { passive: true }
    );

    // Touch swipes count as interaction for screen reader announcements
    this.track.addEventListener(
      'touchstart',
      function () {
        self.userInteracted = true;
      },
      { passive: true }
    );
  };

  SocialCarousel.prototype.bindResize = function () {
    var self = this;
    var onResize = function () {
      self.update();
    };

    if ('ResizeObserver' in window) {
      new ResizeObserver(onResize).observe(this.track);
    } else {
      window.addEventListener('resize', onResize);
    }

    // Lazy images can change slide heights but not widths; recheck once everything has loaded
    window.addEventListener('load', onResize);
  };

  SocialCarousel.prototype.showSlide = function (slide) {
    var index = this.slides.indexOf(slide);
    if (index >= 0) this.goToIndex(index);
  };

  /* Video cards
   *
   * Inactive: the card link (if any) covers the card, and the play button (if shown) sits above it.
   * Autoplay cards preview muted on a loop in this state and never show the play button. They only
   * play while in the viewport, and are treated as non-autoplay for users who prefer reduced motion.
   * Active: the play button and handle hide, native controls appear, and the card link steps aside
   * so the controls can be used. The play button activates with sound. Clicking an autoplay preview
   * pauses it on a still frame with the controls showing, so sound is the customer's choice from
   * there. A non-autoplay card with no play button activates with sound on a frame click. Frame
   * clicks only reach the video when the card has no link, since the link overlay covers it.
   * Once active, the native controls own the frame (browsers toggle play/pause on click) and
   * Escape or the video ending returns the card to inactive.
   */

  SocialCarousel.prototype.bindVideos = function () {
    var self = this;
    var autoplayVideos = [];

    this.videoCards.forEach(function (card) {
      var video = card.querySelector('.js-social-carousel-video');
      var play = card.querySelector('.js-social-carousel-play');
      if (!video) return;

      var autoplay = video.dataset.autoplay === 'true' && !reducedMotion;

      if (autoplay) {
        card.dataset.autoplay = 'true';
        autoplayVideos.push(video);
      }

      if (play) {
        play.addEventListener('click', function () {
          self.activateVideo(card, video, { autoplay: autoplay, sound: true });
        });
      }

      video.addEventListener('click', function () {
        // Native controls handle clicks once the card is active
        if (card.classList.contains('is-playing')) return;

        if (autoplay) {
          self.activateVideo(card, video, { autoplay: true, sound: false });
        } else if (!play) {
          self.activateVideo(card, video, { autoplay: false, sound: true });
        }
      });

      video.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !card.classList.contains('is-playing')) return;
        event.preventDefault();
        self.deactivateVideo(card, video, autoplay);
      });

      video.addEventListener('ended', function () {
        if (video.loop) return;
        self.deactivateVideo(card, video, autoplay);
      });

      // Only one video with sound at a time
      video.addEventListener('play', function () {
        if (!card.classList.contains('is-playing')) return;
        self.pauseOtherVideos(card);
      });
    });

    if (autoplayVideos.length) this.observeAutoplay(autoplayVideos);
  };

  // Autoplay previews only run while on screen, so off-screen cards don't download or decode
  SocialCarousel.prototype.observeAutoplay = function (videos) {
    var self = this;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        self.setInView(video, true);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          self.setInView(entry.target, entry.isIntersecting);
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  };

  SocialCarousel.prototype.setInView = function (video, inView) {
    video.dataset.inView = inView ? 'true' : 'false';
    this.syncPreview(video);
  };

  // Start or stop a muted preview based on visibility, leaving active (sound on) videos alone
  SocialCarousel.prototype.syncPreview = function (video) {
    var card = video.closest('.js-social-carousel-video-card');
    if (!card || card.classList.contains('is-playing')) return;

    if (video.dataset.inView === 'true') {
      if (!video.paused) return;
      video.muted = true;
      video.loop = true;
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    } else if (!video.paused) {
      video.pause();
    }
  };

  SocialCarousel.prototype.activateVideo = function (card, video, options) {
    this.userInteracted = true;

    card.classList.add('is-playing');
    video.controls = true;

    if (options.sound) {
      video.muted = false;
      video.loop = false;
      if (options.autoplay) video.currentTime = 0;

      var playing = video.play();
      if (playing && playing.catch) {
        playing.catch(function () {
          // Playback with sound was blocked; the native controls are now showing so the user can retry
        });
      }
    } else {
      // Autoplay preview: stop on the current frame and hand over to the native controls
      video.pause();
    }

    video.focus({ preventScroll: true });
  };

  SocialCarousel.prototype.deactivateVideo = function (card, video, autoplay) {
    card.classList.remove('is-playing');
    video.controls = false;
    video.pause();

    // Autoplay cards go back to their muted preview if they're on screen
    if (autoplay) {
      video.muted = true;
      video.loop = true;
      this.syncPreview(video);
    }

    var play = card.querySelector('.js-social-carousel-play');
    if (play && card.contains(document.activeElement)) play.focus({ preventScroll: true });
  };

  SocialCarousel.prototype.pauseOtherVideos = function (activeCard) {
    var self = this;

    this.videoCards.forEach(function (card) {
      if (card === activeCard || !card.classList.contains('is-playing')) return;

      var video = card.querySelector('.js-social-carousel-video');
      if (video) self.deactivateVideo(card, video, card.dataset.autoplay === 'true');
    });
  };

  function initSocialCarousel(root) {
    if (!root || root.dataset.socialCarouselInit === 'true') return;
    root.dataset.socialCarouselInit = 'true';
    root.socialCarousel = new SocialCarousel(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.js-social-carousel').forEach(initSocialCarousel);
  }

  window.SocialCarousel = SocialCarousel;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Theme editor: bring the selected card into view
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('.js-social-carousel');
    if (!root || !root.socialCarousel) return;
    root.socialCarousel.showSlide(event.target);
  });
})();
